interface SubscriptionEndpoints {
  GET: string
  CHECKOUT: string
  PORTAL: string
  USAGE: string
  PAUSE: string
  CANCEL: string
  PLANS: string
}

export const SUBSCRIPTION_ENDPOINTS: SubscriptionEndpoints = {
  GET: '/v1/subscription',
  CHECKOUT: '/v1/subscription/checkout',
  PORTAL: '/v1/subscription/portal',
  USAGE: '/v1/subscription/usage',
  PAUSE: '/v1/subscription/pause',
  CANCEL: '/v1/subscription/cancel',
  PLANS: '/v1/subscription/plans',
}
